import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { MobileOptimizedCard } from '@/components/MobileOptimizedCard';
import type { NotificationSettings } from '@/lib/settingsTypes';

interface NotificationsTabProps {
  notificationSettings: NotificationSettings;
  onSettingsChange: (settings: NotificationSettings) => void;
  onSave: () => void;
  isSaving: boolean;
}

export const NotificationsTab = ({
  notificationSettings,
  onSettingsChange,
  onSave,
  isSaving,
}: NotificationsTabProps) => {
  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex items-center space-x-2">
        <Bell className="h-5 w-5" />
        <h2 className="mobile-subheading">Notification Settings</h2>
      </div>
      
      <MobileOptimizedCard title="Email Notifications">
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label>Low Stock Alerts</Label>
              <p className="text-sm text-muted-foreground">
                Get notified when inventory levels are low
              </p>
            </div>
            <Switch 
              checked={notificationSettings.low_stock_alerts}
              onCheckedChange={(checked) => 
                onSettingsChange({ ...notificationSettings, low_stock_alerts: checked })
              }
            />
          </div>
          <Button 
            onClick={onSave}
            disabled={isSaving}
            className="w-full sm:w-auto"
          >
            {isSaving ? 'Saving...' : 'Save Settings'}
          </Button>
        </div>
      </MobileOptimizedCard>
    </div>
  );
};
